// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorHeader-cls1_4Cg","cls2":"AuthorHeader-cls2_P26 AuthorHeader-cls1_4Cg"};